var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 60",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60,8V0H0v8h2v40H1c-0.553,0-1,0.447-1,1s0.447,1,1,1h1h27v2c0,0.047,0.021,0.088,0.027,0.134 C27.292,52.571,26,54.131,26,56c0,2.206,1.794,4,4,4s4-1.794,4-4c0-1.869-1.292-3.429-3.027-3.866C30.979,52.088,31,52.047,31,52 v-2h27h1c0.553,0,1-0.447,1-1s-0.447-1-1-1h-1V8H60z M32,56c0,1.103-0.897,2-2,2s-2-0.897-2-2s0.897-2,2-2S32,54.897,32,56z M56,48 H4V8h52V48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,44c8.822,0,16-7.178,16-16s-7.178-16-16-16s-16,7.178-16,16S21.178,44,30,44z M25,21c0-0.365,0.199-0.701,0.519-0.877 c0.32-0.175,0.709-0.161,1.019,0.033l11,7C37.825,27.34,38,27.658,38,28s-0.175,0.66-0.463,0.844l-11,7 C26.373,35.947,26.187,36,26,36c-0.165,0-0.331-0.041-0.481-0.123C25.199,35.701,25,35.365,25,35V21z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.191208b450583bd086224df17b1124d1.svg";
export { ForwardRef as ReactComponent };